import Vue from 'vue';
import _ from 'lodash';
import {uuid} from 'vue-uuid';

export default {
  state: {
    set: null,
    sets: null,
    setPhotos: null,
    replacedPhotoProduct: false,
  },
  getters: {
    SET: state => {
      return state.set;
    },
    SETS: state => {
      return state.sets;
    },
    SET_PHOTOS: state => {
      return state.setPhotos;
    },
    REPLACED_PHOTO_DATA: state => {
      return state.replacedPhotoProduct;
    },
  },
  mutations: {
    SET_SET: (state, payload) => {
      state.set = payload;
    },
    SET_SETS: (state, payload) => {
      state.sets = payload;
    },
    SET_SET_PHOTOS: (state, payload) => {
      state.setPhotos = payload;
    },
    SET_REPLACED_PHOTO_PRODUCT: (state, payload) => {
      state.replacedPhotoProduct = payload;
    },
  },
  actions: {
    INIT_SET_MATCH: async (context, data) => {
      const loader = Vue.$loading.show();

      try {
        const albumItem = context.getters.PHOTO;
        const albumTag = context.getters.ALBUM_TAG;
        const response = await Vue.axios.get(`v2/sets/${data.set_id}/match?album_id=${data.album.id}${albumItem ? `&album_item_id=${albumItem.id}` : ''}${albumTag ? `&tag=${albumTag}` : ''}`);
        const set = context.getters.SET;
        const products = [];

        response.data.data.forEach((item) => {
          const initProduct = context.getters.PRODUCTS ? _.find(context.getters.PRODUCTS, {id: item.product.category.id || 0}) : null;

          const product = {
            id: item.id,
            name: item.name,
            product_name: item.product.name,
            product_images: [],
            product_category_id: item.product.category.id || 0,
            product_category_blocked_album_items: initProduct ? initProduct.blockedAlbumItems : null,
            product_is_downloadable: item.product.category.is_downloadable,
            quantity: item.quantity,
            pricelist_set_product_id: item.id,
            is_additional_product: item.product.category.type === 'additional',
            image_tag: null,
            width: item.variant.width,
            height: item.variant.height,
            photo: null,
          };

          if (product.is_additional_product && item.product.images && item.product.images.length > 0) {
            product.product_images = item.product.images;
          }

          if (item.match) {
            const photo = _.find(data.album.album_items,
                {id: item.match.album_item_id});

            product.image_tag = item.match.image_tag ? item.match.image_tag : null;
            product.photo = photo ? {
              id: photo.id,
              productId: item.id,
              large_photo: photo.large_photo,
              medium_photo: photo.medium_photo,
              dimensions: photo.dimensions,
              processing: {
                filter: null, cropper: {data: null, cropBoxData: null},
              },
            } : null;

            if (product.photo) {
              product.photo.processing = {
                filter: null, cropper: {data: null, cropBoxData: null},
              };
            }
          }

          products.push(product);
        });

        if (products.length > 0 && set) {
          set.products = products;
        }

        context.commit('SET_SET', set);
        loader.hide();
        return set;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    SET_SET: (context, set) => {
      context.commit('SET_SET', set ? {
        id: set.id,
        uuid: uuid.v1(),
        name: set.name,
        thumb_image: set.images && set.images.length > 0 ? _.first(set.images).thumb : null,
        price: set.price_gross,
        quantity: 1,
        total: set.price_gross,
        products: [],
      } : null);
    },
    SET_SETS: (context, sets) => {
      context.commit('SET_SETS', sets);
    },
    SET_SET_PHOTOS: (context, setPhotos) => {
      context.commit('SET_SET_PHOTOS', setPhotos);
    },
    SET_REPLACED_PHOTO_PRODUCT: (context, data) => {
      context.commit('SET_REPLACED_PHOTO_PRODUCT', data);
    },
    CLEAR_SET: (context) => {
      context.commit('SET_SET', null);
      context.commit('SET_SET_PHOTOS', null);
      context.commit('SET_UUID', null);
      context.commit('SET_REPLACED_PHOTO_PRODUCT', false);
    },
  },
};